// extracted by mini-css-extract-plugin
module.exports = {"imagegrid":"imagegrid-module--imagegrid--6wR-S","column":"imagegrid-module--column--cDc_d","link":"imagegrid-module--link--JrjfD"};